import api from './index';
//
let exports = {};

// 资产入库操作
exports.saveAssetStockIn = function (postData, callback) {
    api.post('/asset/stockIn/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// （零售商）资产分类计量单位记录-unitList
exports.getAssetCatUnitList = function (params, callback) {
    api.get('/asset/cat/unit/list/get')
    .params(params)
    .done(callback)
    .go();
};
//  财务类别-查询
exports.getAssetKind = function (params, callback) {
    api.get('/asset/kind/get')
    .params(params)
    .done(callback)
    .go();
};
//  财务类别-查询
exports.getAssetKindListByParentId = function (data, callback) {
    api.post('/asset/kind/get/by/parentId')
    .data(data)
    .done(callback)
    .go();
};
// 财务类别-列表
exports.getAssetKindTreeList = function (params, callback) {
    api.post('/asset/kind/list/tree/get')
    .data(params)
    .done(callback)
    .go();
};
// 财务类别-列表
exports.getAssetKindList = function (params, callback) {
    api.post('/asset/kind/list/tree/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getAssetKindListAll = function (params, callback) {
    api.post('/asset/kind/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 财务类别-列表
exports.getAssetKindPageList = function (params, callback) {
    // api.post('/asset/kind/list/page/get')
    api.post('/finac2/fiscal/kind/page/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 财务类别-保存
exports.saveAssetKind = function (postData, callback) {
    api.post('/asset/kind/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 财务类别-修改
exports.updateAssetKind = function (postData, callback) {
    api.post('/asset/kind/update/do')
    .data(postData)
    .done(callback)
    .go();
};
// 财务类别-删除
exports.deleteAssetKind = function (postData, callback) {
    api.post('/asset/kind/delete/do')
    .data(postData)
    .done(callback)
    .go();
};
// 财务类别-上下移动
exports.moveAssetKindSeq = function (postData, callback) {
    api.post('/asset/kind/seq/move/do')
    .data(postData)
    .done(callback)
    .go();
};
// 财务类别-关联数据
exports.getAssetKindRel = function (postData, callback) {
    api.post('/asset/kind/rel/get')
    .data(postData)
    .done(callback)
    .go();
};
// 财务类别-关联数据同步
exports.doSyncAssetKindRel = function (postData, callback) {
    api.post('/asset/kind/rel/sync/do')
    .data(postData)
    .done(callback)
    .go();
};
//
// 折旧规格-列表
exports.getDeprSpecPageList = function (params, callback) {
    api.post('/asset/deprSpec/list/page/get')
    .data(params)
    .done(callback)
    .go()
}
//  折旧规格-查询
exports.getDeprSpec = function (params, callback) {
    api.get('/asset/deprSpec/get')
    .params(params)
    .done(callback)
    .go()
}

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/asset.js
// module id = 38
// module chunks = 0